import * as React from 'react'
import { isPC, replaceWkDomain } from '../../../../utils/tools'
import SwipeableViews from 'react-swipeable-views'
// tslint:disable-next-line
const {autoPlay} = require('react-swipeable-views-utils')
import * as Styles from './HomeSwiper.style'
import HomeType from '../../types/HomeType'
import {classes} from 'typestyle'
import {ImageView} from '../ImageView/ImageView'
import { reportClickEvent } from '../../../../services/operationReport'
import { RegisterElement } from '../../../../services/hotspotReport'
const AutoPlaySwipeableViews = autoPlay(SwipeableViews)

interface HomeSwiperProp {
    content?: HomeType.Banner[]
    interval?: number
}

interface HomeSwiperState {
    playIndex: number,
    banner: HomeType.Banner[] | undefined,
    isShowController: boolean
}

const styles = {
    slide: {
        overflow: 'hidden',
        borderRadius: 6
    }
}

export default class HomeSwiper extends React.Component <HomeSwiperProp, HomeSwiperState> {
    constructor(props: HomeSwiperProp) {
        super(props)
        this.linkTo = this.linkTo.bind(this)
        this.state = {
            playIndex: 0,
            banner: [],
            isShowController: false
        }
    }
    public componentDidMount() {
        const {content} = this.props
        this.setState({
            banner: content
        })
    }
    public linkTo = (item: HomeType.Banner, index: number): void => {
        if (!/category/.test(window.location.href)) {
            reportClickEvent(RegisterElement.top_banner, { index, url: item.url, object_id: item.object_id })
        }
        setTimeout(() => {
            window.location.assign(replaceWkDomain(item.url))
        }, 150)
    }
    public handleChangeIndex = (val: number) => {
        this.setState({
            playIndex: val
        })
    }
    public carouselControllerLeft = () => {
        const {playIndex, banner} = this.state
        if (banner !== undefined && playIndex  === 0) {
            this.setState({
                playIndex: banner.length - 1
            })
        } else {
            this.setState({
                playIndex: this.state.playIndex - 1
            })
        }
    }
    public carouselControllerRight = () => {
        const {playIndex, banner} = this.state
        if (banner !== undefined && playIndex + 1 === banner.length) {
           this.setState({
               playIndex: 0
           })
        } else {
            this.setState({
                playIndex: playIndex + 1
            })
        }
    }
    public componentWillReceiveProps(nextProps: any) {
        if (nextProps) {
            this.setState({
                playIndex: 0,
                banner: nextProps.content
            })
        }
    }

    public handleMouseEnter = () => {
       if (this.state.isShowController) {
           return
       }
       this.setState({
           isShowController: true
       })
    }

    public handleMouseLeave = () => {
        if (!this.state.isShowController) {
            return
        }
        this.setState({
            isShowController: false
        })
    }

    public render() {
        return (
            <div className={Styles.HomeSwiper} onMouseEnter={this.handleMouseEnter} onMouseLeave={this.handleMouseLeave}>
                <AutoPlaySwipeableViews
                    enableMouseEvents={isPC() ? false : true}
                    resistance={true}
                    index={this.state.playIndex}
                    onChangeIndex={this.handleChangeIndex}
                    style={{borderRadius: 4}}
                    interval={this.props.interval || 5000}
                >
                    {this.state.banner !== undefined && this.state.banner.map((v: HomeType.Banner, index) => (
                        <div style={Object.assign({}, styles.slide)} key={index}>
                            <div onClick={() => this.linkTo(v, index)} className={Styles.bannerImg}>
                                <ImageView url={v.image} width={800}/>
                            </div>
                        </div>
                    ))}
                </AutoPlaySwipeableViews>
                <div className={Styles.playPoint}>
                    {this.state.banner !== undefined && this.state.banner.map((v: HomeType.Banner, index) => (
                        <div className={classes(Styles.point, index === this.state.playIndex ? Styles.pointActive : '')} key={index}/>
                    ))}
                </div>
                {isPC() && this.state.isShowController && <div>
                    <span className={Styles.carouselControllerLeft} onClick={this.carouselControllerLeft}>
                        <i/>
                    </span>
                    < span className={Styles.carouselControllerRight} onClick={this.carouselControllerRight}>
                        <i/>
                    </span>
                </div>}
            </div >
        )
    }
}



// WEBPACK FOOTER //
// ./src/views/Home/components/HomSwiper/HomeSwiper.tsx